import {Inject, Injectable, makeStateKey, Optional, RESPONSE_INIT, StateKey, TransferState} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {StorageService} from './storage.service';
import {NavigationService} from './navigation.service';
import {ToastService} from './toast.service';
import {StorableService} from './storable.service';
import {GoldenTip} from '../classes/golden-tip';
import {GoldenTipDTO} from '../dto/golden-tip-dto';
import {PlatformService} from './platform.service';

@Injectable({
  providedIn: 'root'
})
export class GoldenTipService extends StorableService<GoldenTipDTO, GoldenTip> {

  constructor(http: HttpClient, storageService: StorageService, transferState: TransferState,
              navigationService: NavigationService, toastService: ToastService, platformService: PlatformService,
              @Optional() @Inject(RESPONSE_INIT) response?: ResponseInit) {
    super(http, storageService, transferState, navigationService, toastService, platformService, response);
  }

  readonly tableName = 'goldenTips';

  readonly endpoint = '/golden-tips';

  get stateKey(): StateKey<GoldenTipDTO[]> {
    return makeStateKey('golden-tips');
  }

  protected createData(dto: GoldenTipDTO): GoldenTip {
    return new GoldenTip(dto);
  }
}